// Copyright 2023 Sorama B.V.
import { CamIv64Device } from "services/Hardware/CamHTTP/CamIV64Helpers";
import { CamIV64Service } from "services/Hardware/CamHTTP/CamIV64Service";

export class CamIV64ServiceMock extends CamIV64Service {
    public async refresh(): Promise<void> {
        // Make sure that we're piggybacking already pending refresh calls.
        if (this.hardwarePromise) {
            return this.hardwarePromise;
        }

        this.isRefreshing = true;
        this.hardwarePromise = this.retrieveHardware();
        try {
            await this.hardwarePromise;
        } catch (e) {
            console.error("Error retrieving hardware:", e);
        } finally {
            this.isRefreshing = false;
            this.hardwarePromise = null;
        }
    }

    private async retrieveHardware(): Promise<void> {
        // Simulate a delay to mimic real hardware retrieval
        await new Promise((resolve) => setTimeout(resolve, 500));
        const cams = ["sorama-iv64-123456789", "sorama-iv64s-333666999", "sorama-iv64ex-000000000"];
        this.hardware = cams.map((x) => {
            return new CamIv64Device(x);
        });

        //Remove current selection if cam is unavailable
        if (!this.hardware.map((x) => x.id).includes(this.selectedDeviceId)) {
            this.selectedDeviceId = "";
        }

        //Just one CAM, select it for that sweet sweet UX
        if (this.hardware.length == 1) {
            this.selectedDeviceId = this.hardware[0].id;
        }
    }
}
